import { assignConditionalProperty, mergeConditionalProperty } from '../util';
import { isBatchedStyles, isSelector } from './util';
function isMedia(value) {
    return typeof value === 'object' && !isBatchedStyles(value);
}
export function assignStyleProperty(styles, property, value, media = '') {
    assignConditionalProperty(styles, property, value, media, isMedia);
}
export function assignStyle(target, source) {
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const styles = target;
        const property = keys[i];
        const value = source[property];
        if (isSelector(property)) {
            const targetValue = styles[property];
            if (targetValue) {
                assignStyle(targetValue, value);
            } else {
                styles[property] = {
                    ...value
                };
            }
        } else {
            mergeConditionalProperty(styles, property, value, isMedia);
        }
    }
    return target;
}

//# sourceMappingURL=assignStyle.js.map